// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"38f99317","312":"73873d36","563":"842ccb9e","973":"efcf19b9"}[chunkId] + ".chunk.js";
};